import { FormValidationRule } from "../types";

const regexValidation: FormValidationRule = (c, v) => {
    let valid = true;
    let errorMessage = "You've entered an invalid character.";
    if (c.field_regex_validation && c.field_regex_validation !== "" && v) {
        const regexValidator = new RegExp(`^${c.field_regex_validation}$`);
        !regexValidator.test(v) ? (valid = false) : (errorMessage = "");
    }

    return [valid, c.errorMessage || errorMessage];
};

export default regexValidation;
